import React, { useEffect, useState } from 'react';
import { MenuIcon, XIcon, MessageCircleIcon } from 'lucide-react';
import { NAV_LINKS, WHATSAPP_URL } from '../data/content';
export function Header() {
  const [scrolled, setScrolled] = useState(false);
  const [open, setOpen] = useState(false);
  useEffect(() => {
    const onScroll = () => setScrolled(window.scrollY > 24);
    onScroll();
    window.addEventListener('scroll', onScroll, {
      passive: true
    });
    return () => window.removeEventListener('scroll', onScroll);
  }, []);
  return <header className={`fixed inset-x-0 top-0 z-50 transition-[background-color,border-color,backdrop-filter] duration-300 ease-premium ${scrolled || open ? 'border-b border-ink/10 bg-cream/90 backdrop-blur-md' : 'border-b border-transparent bg-transparent'}`} data-id="element-256" data-mp="2wk72oijur7s2">
      <div className="mx-auto flex h-20 max-w-content items-center justify-between px-6 lg:px-10" data-id="element-257" data-mp="3bbg0vg1tm1gt">
        <a href="#top" className={`font-serif text-2xl tracking-[0.22em] transition-colors duration-200 ease-premium ${scrolled || open ? 'text-ink' : 'text-cream'}`} data-id="element-258" data-mp="3fcjahkt9z19l">
          LUSSONOVO
        </a>

        <nav aria-label="Principal" className="hidden items-center gap-9 lg:flex" data-id="element-259" data-mp="2mmeuios2y5vq">
          {NAV_LINKS.map(link => <a key={link.href} href={link.href} className={`relative text-[13px] tracking-wide transition-colors duration-200 ease-premium after:absolute after:-bottom-1.5 after:left-0 after:h-px after:w-0 after:bg-champagne after:transition-[width] after:duration-300 after:ease-premium hover:after:w-full ${scrolled ? 'text-stone-600 hover:text-ink' : 'text-cream/80 hover:text-cream'}`} data-id="element-260" data-mp="2hodao1mty2j7">
              {link.label}
            </a>)}
        </nav>

        <div className="flex items-center gap-3" data-id="element-261" data-mp="1yirs6krdwif">
          <a href={WHATSAPP_URL} target="_blank" rel="noopener noreferrer" className={`hidden items-center gap-2 rounded-full px-5 py-2.5 text-[12.5px] font-medium tracking-wide transition-[background-color,color,border-color] duration-200 ease-premium sm:inline-flex ${scrolled ? 'bg-ink text-cream hover:bg-charcoal' : 'border border-cream/40 text-cream hover:bg-cream hover:text-ink'}`} data-id="element-262" data-mp="3tavcqxey87pp">
            <MessageCircleIcon className="h-4 w-4" aria-hidden="true" data-id="element-263" data-mp="18mae0392xb97" />
            WhatsApp
          </a>
          <button type="button" onClick={() => setOpen(v => !v)} aria-expanded={open} aria-label={open ? 'Cerrar menú' : 'Abrir menú'} className={`inline-flex h-10 w-10 items-center justify-center rounded-full border transition-colors duration-200 ease-premium lg:hidden ${scrolled || open ? 'border-ink/15 text-ink' : 'border-cream/30 text-cream'}`} data-id="element-264" data-mp="1cpggr0wzgkax">
            {open ? <XIcon className="h-5 w-5" data-id="element-265" data-mp="me4ywjlzobmp" /> : <MenuIcon className="h-5 w-5" data-id="element-266" data-mp="mfg1ig3p7dc8" />}
          </button>
        </div>
      </div>

      {open && <nav aria-label="Menú móvil" className="border-t border-ink/10 bg-cream px-6 pb-8 pt-4 lg:hidden" data-id="element-267" data-mp="hh4sg7l896v2">
          <ul className="divide-y divide-ink/10" data-id="element-268" data-mp="w6am7g1aq4vk">
            {NAV_LINKS.map(link => <li key={link.href} data-id="element-269" data-mp="rbwp996zjpos">
                <a href={link.href} onClick={() => setOpen(false)} className="block py-3.5 font-serif text-xl text-ink" data-id="element-270" data-mp="154mls7k54d05">
                  {link.label}
                </a>
              </li>)}
          </ul>
        </nav>}
    </header>;
}